import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import classNames from 'classnames'
import Header from 'components/Header/Header'
import Menu from '../components/Menu/Menu'
import Arrow from 'components/assets/icons/Arrow'
import { pages, GetPageIndex } from 'components/RCPro/helpers/nav'
import style from './Wrapper.module.scss'
import PoweredBy from 'components/assets/icons/PoweredBy'

const Wrapper = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const pageIndex = GetPageIndex()
  const [ previousPage, setPreviousPage ] = useState(false)
  const [ nextPage, setNextPage ] = useState(false)
  // Partner logo will be a state in the future
  const partnerLogo = '<svg width="103" height="20" viewBox="0 0 103 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.0298 13.0637H30.9181L29.9104 15.4394H27.9534L32.5539 5.17383H34.4233L39.0384 15.4394H37.0521L36.0298 13.0637ZM35.4018 11.5678L33.474 7.0803L31.5607 11.5678H35.4018Z" fill="#234371"/><path d="M47.1733 15.4394L44.3984 11.5385L41.6527 15.4394H39.4912L43.2884 10.204L39.6957 5.17383H41.8426L44.4568 8.82545L47.0419 5.17383H49.1011L45.523 10.1307L49.364 15.4394H47.1733Z" fill="#234371"/><path d="M52.022 14.9043C51.1822 14.4497 50.525 13.8191 50.0504 13.0125C49.5757 12.2059 49.3347 11.304 49.3347 10.3068C49.3347 9.30957 49.5757 8.40766 50.0504 7.60108C50.525 6.7945 51.1822 6.16389 52.022 5.70927C52.8618 5.25465 53.7965 5.02734 54.8407 5.02734C55.8849 5.02734 56.8196 5.25465 57.6594 5.70927C58.4992 6.16389 59.1564 6.7945 59.6311 7.59375C60.1057 8.393 60.3467 9.30224 60.3467 10.3068C60.3467 11.3114 60.1057 12.2206 59.6311 13.0199C59.1564 13.8191 58.4992 14.4497 57.6594 14.9043C56.8196 15.359 55.8849 15.5863 54.8407 15.5863C53.7965 15.5863 52.8618 15.359 52.022 14.9043ZM56.6809 13.4525C57.2286 13.1445 57.6521 12.7119 57.9661 12.1619C58.2801 11.612 58.4335 10.9887 58.4335 10.3068C58.4335 9.62487 58.2801 9.0016 57.9661 8.45166C57.6521 7.90172 57.2286 7.46909 56.6809 7.16113C56.1332 6.85316 55.5198 6.69917 54.8407 6.69917C54.1616 6.69917 53.5482 6.85316 53.0005 7.16113C52.4528 7.46909 52.0293 7.90172 51.7153 8.45166C51.4013 9.0016 51.2479 9.62487 51.2479 10.3068C51.2479 10.9887 51.4013 11.612 51.7153 12.1619C52.0293 12.7119 52.4528 13.1445 53.0005 13.4525C53.5482 13.7604 54.1616 13.9144 54.8407 13.9144C55.5198 13.9144 56.1405 13.7604 56.6809 13.4525Z" fill="#234371"/><path d="M71.0959 5.17383V15.4394H69.5332L63.8957 8.48815V15.4394H62.0117V5.17383H63.5744L69.2118 12.1251V5.17383H71.0959Z" fill="#234371"/><path d="M80.1873 13.0637H75.0756L74.0679 15.4394H72.1108L76.7113 5.17383H78.5807L83.1958 15.4394H81.2096L80.1873 13.0637ZM79.5593 11.5678L77.6314 7.0803L75.7182 11.5678H79.5593Z" fill="#234371"/><path d="M84.744 14.3909C83.9554 13.5916 83.561 12.4551 83.561 10.9666V5.17383H85.4596V10.8932C85.4596 12.9097 86.3286 13.9143 88.0593 13.9143C89.7899 13.9143 90.6443 12.9097 90.6443 10.8932V5.17383H92.5137V10.9666C92.5137 12.4551 92.1194 13.5916 91.3381 14.3909C90.5567 15.1901 89.454 15.5861 88.0447 15.5861C86.6353 15.5861 85.5327 15.1901 84.744 14.3909Z" fill="#234371"/><path d="M96.9462 6.787H93.5579V5.17383H102.233V6.787H98.8448V15.4394H96.9462V6.787Z" fill="#234371"/><path d="M20.2202 12.1395C16.2551 11.5675 13.3487 8.09189 13.4802 4.07364C13.5094 3.13506 13.21 2.18183 12.5601 1.41191C11.1653 -0.259921 8.68251 -0.479898 7.01757 0.927958C5.35263 2.32848 5.13356 4.82156 6.53562 6.49339C7.18553 7.27064 8.06181 7.73259 8.98921 7.86458C11.0704 8.16522 12.8595 9.2651 14.0717 10.8269C15.1451 12.3301 14.7873 14.8012 12.1657 15.1165C10.1649 15.2118 8.14214 14.5446 6.55022 13.1147C5.8565 12.4914 4.9364 12.1101 3.92867 12.1101C1.75987 12.1028 0 13.87 0 16.0477C0 18.2255 1.75987 20 3.93597 20C4.9437 20 5.8638 19.6187 6.55752 18.9954C9.54419 16.3117 14.0644 16.3117 17.0437 18.9954C17.7374 19.6187 18.6575 20 19.6653 20C21.8341 20 23.6012 18.2328 23.6012 16.0477C23.6012 14.0606 22.1335 12.4108 20.2202 12.1395ZM10.8148 5.45949C9.98233 6.16342 8.74093 6.05343 8.0472 5.21752C7.34618 4.3816 7.45571 3.13506 8.28818 2.43847C9.12065 1.73454 10.3621 1.84453 11.0558 2.68044C11.7495 3.51636 11.6473 4.75557 10.8148 5.45949ZM3.92867 18.0202C2.84062 18.0202 1.96434 17.133 1.96434 16.0477C1.96434 14.9552 2.84792 14.0753 3.92867 14.0753C5.00942 14.0753 5.89301 14.9625 5.89301 16.0477C5.90031 17.1403 5.01672 18.0202 3.92867 18.0202ZM19.6653 18.0202C18.5772 18.0202 17.7009 17.133 17.7009 16.0477C17.7009 14.9552 18.5845 14.0753 19.6653 14.0753C20.7533 14.0753 21.6296 14.9625 21.6296 16.0477C21.6296 17.1403 20.7533 18.0202 19.6653 18.0202Z" fill="#234371"/></svg>'

  // Infobulles
  const getMessages = () => {
    const oldesIndex = pageIndex - 3 < 0 ? 0 : pageIndex - 3
    return state?.texts.infobulles?.slice(oldesIndex, pageIndex)
  }

  // Transition to previous page
  const previousPageTransition = () => {
    setPreviousPage(true)
    setTimeout( () => navigate('./'+pages[pageIndex-1], { state }), 250)
    setTimeout( () => setPreviousPage(false), 500)
  }

  // Transition to next page
  const nextPageTransition = () => {
    setNextPage(true)
    setTimeout( () => setNextPage(false), 500)
  }


  return pageIndex > 0 && !state
  ? <Navigate to={'/not-found'} replace />
  : (
    <div className={style.bg}>
      <Header
        logo={partnerLogo &&
          <div className={style.cobranding}>
            <span dangerouslySetInnerHTML={{__html: partnerLogo}}></span>
            <PoweredBy />
          </div>
        }
      />

      {![0, 6, 7].includes(pageIndex) && 
        <Menu texts={{
          menu1: state?.texts['menu 1'],
          menu2: state?.texts['menu 2']
        }} />
      }

      <main className={classNames(
        style.content,
        (pageIndex === 0 || pageIndex > 6) && style.singleBloc,
        pageIndex === 6 && style.estimate,
        previousPage && style.previousPage,
        nextPage && style.nextPage
      )}>
        <div>
          {![0, 1, 6, 7].includes(pageIndex) &&
            <span className={style.back} onClick={previousPageTransition}>
              <Arrow/> Retour
            </span>
          }
          <Outlet context={[nextPageTransition]} />
        </div>
      </main>

      {(pageIndex > 0 && pageIndex < 6) && 
        <aside className={classNames(
          style.chat,
          previousPage && style.previousPage,
          nextPage && style.nextPage
        )}>
          <ul>
            {
              getMessages()?.map( (msg, index) => (
                msg && <li key={`msg-${index}`}>
                  <header>{msg.title}</header>
                  <p>{msg.message}</p>
                </li>
              ))
            }
          </ul>
        </aside>
      }
    </div>
  )
}

export default Wrapper